import { useItemFunctionMenuItemsType } from '../../../../../../Utils/ObjektVyUtils';
import { useDeleteFunctionMenuItem } from '../../../../../../Hooks/useDeleteItem';
import { useBusinessConfig } from '../../../../../../Components/BusinessConfigContext/BusinessConfigContext';

export const useDefaultFunctionMenu: useItemFunctionMenuItemsType = input => {
  let collectionPart = input.associationName ? `${input.associationName}/` : '';
  let baseUrl = window.location.href;
  if (baseUrl.slice(-1) !== '/') {
    baseUrl = `${baseUrl}/`;
  }
  const url = `${baseUrl}${collectionPart}${input.id}/`;

  const businessConfig = useBusinessConfig(input.collection?.CollectionName);

  return [
    {
      id: 'Öppna i ny flik',
      caption: 'Öppna i ny flik',
      onClick: () => {
        if (input.collection) {
          window.open(url, '_blank');
        }
      },
      iconType: 'open_in_new',
    },
    useDeleteFunctionMenuItem(input, businessConfig),
  ];
};
